import React from "react";

const RunningHelpPanel = () => (
    <div className="running-help-panel">
        <section>
            <h6>Princípios da tela</h6>
            <ul>
                <li>O essencial é criar os blocos e segmentos do treino.</li>
                <li>Modo Clube e Ciclo são opcionais e devem ser ativados só quando necessários.</li>
                <li>Labels ficam sempre visíveis; placeholders servem apenas como exemplo de preenchimento.</li>
                <li>Use o Modo Professor para revisar se a sessão está clara antes de prescrever.</li>
            </ul>
        </section>

        <section>
            <h6>Como criar um treino de corrida</h6>
            <ol>
                <li>Escolha uma sessão da biblioteca ou monte os blocos manualmente.</li>
                <li>Defina se o treino é individual ou de clube.</li>
                <li>Configure objetivo, local, rota, grupos de pace e logística.</li>
                <li>Monte os segmentos: aquecimento, tiros, recuperação e desaquecimento.</li>
                <li>Revise volume, duração, zonas e modo professor antes de prescrever.</li>
            </ol>
        </section>

        <section>
            <h6>Fluxo de Criação Recomendado</h6>
            <ol style={{ listStyleType: "none", paddingLeft: 0 }}>
                <li className="mb-2">
                    <strong className="text-dark d-block">1. Comece simples</strong>
                    <span className="font-size-12 text-muted">Use a biblioteca de sessões prontas ou monte os blocos e segmentos de treino de forma manual no editor.</span>
                </li>
                <li className="mb-2">
                    <strong className="text-dark d-block">2. Defina o contexto</strong>
                    <span className="font-size-12 text-muted">Ative o Modo Clube se a sessão for para turmas/grupos de corrida, definindo local, rota e grupos de pace se houver.</span>
                </li>
                <li className="mb-2">
                    <strong className="text-dark d-block">3. Planeje a carga</strong>
                    <span className="font-size-12 text-muted">Use o planejamento de ciclo ou prova se este treino fizer parte de uma preparação maior e estruturada.</span>
                </li>
                <li className="mb-2">
                    <strong className="text-dark d-block">4. Revise e entregue</strong>
                    <span className="font-size-12 text-muted">Analise as informações e a clareza da sessão usando o Modo Professor (breve operacional), salve na biblioteca para reutilizar ou exporte para relógios.</span>
                </li>
            </ol>
        </section>


        <section>
            <h6>Quando usar cada área</h6>
            <dl>
                <dt>Biblioteca de Sessões</dt>
                <dd>Use para reaproveitar treinos prontos como 6x400m, longão Z2, fartlek e subidas.</dd>
                <dt>Modo Clube</dt>
                <dd>Use quando uma mesma sessão será aplicada para turma, assessoria ou grupos de pace.</dd>
                <dt>Ciclo e Prova</dt>
                <dd>Use quando o treino faz parte de uma preparação para 5K, 10K, meia, maratona ou outro objetivo com data.</dd>

                <dt>Modo Professor</dt>
                <dd>Use para ver a versão operacional do treino, mais fácil de explicar na pista ou na rua.</dd>
                <dt>Exportar Relógio</dt>
                <dd>Gera um JSON estruturado por grupo de pace, base para futura conversão Garmin/FIT/TCX.</dd>
            </dl>
        </section>

        <section>
            <h6>Campos do segmento</h6>
            <dl>
                <dt>Tipo</dt>
                <dd>Define a intenção do passo: aquecimento, corrida, tiro, recuperação, educativo, subida ou desaquecimento.</dd>
                <dt>Repetir</dt>
                <dd>Use quando o mesmo segmento se repete dentro do bloco. Para séries complexas, prefira repetir o bloco.</dd>
                <dt>Base</dt>
                <dd>Define se o relógio/aluno seguirá por distância, tempo, livre, botão de volta, FC ou potência.</dd>
                <dt>Alvo</dt>
                <dd>Define o controle principal: pace, frequência cardíaca, potência, cadência, esforço ou sem alvo.</dd>
                <dt>Zona</dt>
                <dd>Ajuda a controlar a intensidade e alimentar o resumo de distribuição do treino.</dd>
                <dt>Recuperação após</dt>
                <dd>Descreve a pausa ou trote depois do segmento, como 90s trote ou 200m leve.</dd>
            </dl>
        </section>

        <section>
            <h6>Objetivos práticos</h6>
            <ul>
                <li><strong>Base:</strong> priorize Z1/Z2, volume controlado e regularidade.</li>
                <li><strong>5K/10K:</strong> use tiros, limiar, progressivos e controle de pace.</li>
                <li><strong>Meia/Maratona:</strong> use longões, ritmo controlado, volume semanal e semanas regenerativas.</li>
                <li><strong>Retorno:</strong> use caminhada/corrida, esforço baixo e controle de fadiga.</li>
                <li><strong>Clube:</strong> configure grupos de pace para não criar treinos duplicados.</li>
            </ul>
        </section>

        <section>
            <h6>Checklist antes de salvar</h6>
            <ul>
                <li>O volume total está coerente com a semana?</li>
                <li>O treino tem aquecimento e desaquecimento?</li>
                <li>Os paces por grupo estão preenchidos nos tiros?</li>
                <li>A logística do clube está clara?</li>
                <li>O modo professor explica o treino sem depender de texto extra?</li>
            </ul>
        </section>
    </div>
);

export default RunningHelpPanel;
